import React, { useState } from "react";

const faqData = [
  {
    question: "Is there a limit of min or max users?",
    answer:
      "We currently support requests for ten (10) user seats and above. If your team grows in the future, more seats can be purchased at any time.",
  },
  {
    question: "How does the pricing work for company access?",
    answer:
      "Academy for Business works with annual licences per employee, by purchasing user seats. To know more details, please submit the form below and our business team will get back to you right away.",
  },
  {
    question: "Does Academy For Business offer industry certifications?",
    answer:
      "Yes! All HTB Academy Job-role paths will result in a certification. You can see the available certifications in the following link: https://academy.hackthebox.com/preview/certifications\nEach Academy for Business seat comes with unlimited exam attempts for no additional cost (limited time offer). Please note that the number of certificates that can be obtained is equal to the number of purchased seats.",
  },
  {
    question: "What kind of IT teams usually utilize this platform?",
    answer:
      "Due to the rich variety of the modules being offered in HTB Academy — covering Offensive, Defensive, and General Security — the platform is being utilized by IT professionals of diverse expertise. The training material scales from fundamental to advanced difficulty, so larger IT teams can join the platform and shape their skill set. Apart from cybersecurity professionals, any IT practitioner can find something new to learn like Secure Coding 101: JavaScript for software engineers and Linux Fundamentals for junior sysadmins.",
  },
  {
    question: "Do you offer customer support for technical issues?",
    answer:
      "Of course. For any technical problems, employees can access the live support system. For anything account related, the admin may reach out to their dedicated Technical Account Manager.",
  },
  {
    question: "Can I earn CPE credits through HTB Academy?",
    answer:
      "Yes! CPE credit submission is available to our subscribed members. Subscribed members can obtain credits by completing Hack The Box Academy modules, Tier I and above. In order to start tracking your activity and automatically get your credits, you just need to enable this option through your account settings.\n\nHere is how CPE credits are allocated:\nFundamental modules: 2 CPE credits\nEasy modules: 4 CPE credits\nMedium modules: 6 CPE credits\nHard modules: 8 CPE credits",
  },
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) =>
    setActiveIndex(activeIndex === index ? null : index);

  return (
    <div className="bg-gradient-to-r from-red-600 to-blue-700 min-h-screen text-white py-16 px-4 md:px-12">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
        Frequently Asked Questions
      </h2>

      <div className="max-w-4xl mx-auto space-y-4">
        {faqData.map((faq, index) => (
          <div
            key={index}
            className={`bg-black/50 rounded-xl p-5 cursor-pointer transition-all duration-300 ${
              activeIndex === index ? "shadow-xl" : "hover:shadow-lg"
            }`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="text-lg font-semibold flex justify-between items-center">
              {faq.question}
              <span className="text-green-400 text-2xl">
                {activeIndex === index ? "−" : "+"}
              </span>
            </div>
            {activeIndex === index && (
              <div className="mt-3 text-gray-300 whitespace-pre-line">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="text-center mt-8">
        <a href="#" className="text-yellow-300 hover:underline">
          View all frequently asked questions &gt;
        </a>
      </div>
    </div>
  );
};

export default FAQ;
